import { useContext, useEffect, useState } from "react";
import { FormCadastro } from "./components/form-cadastro";
import { Historico } from "./components/historico";
import { FormPropostas } from "./components/form-proposta";
import { FormNeg } from "./components/form-neg";
import { Credor, useDividas } from "../../../context/DividasContext";
import { useIsMutating } from "@tanstack/react-query";
import { Loader } from "../../generics/loader";
import { useContrato } from "../../../context/ContratoContext";
import { usePropostas } from "../../../context/PropostasContext";
import { ModalSucesso } from "../../Modal/components/sucesso";
import { ModalTabFinalizar } from "../../Modal/components/tab-finalizar";
import { useHistorico } from "../../../context/HistoricoContext";
import { useBoleto } from "../../../context/BoletoContext";
import { ModalErro } from "../../Modal/components/erro";
import { GenericModal } from "../../Modal";
import { useModal } from "../../../hooks/ModalContext";
import { ContraProposta } from "./components/contra-proposta";
import { SegundaVia } from "./components/segunda-via";
import { useNeg } from "../../../context/NegContext";
import { ConsultaContratosData, Contrato } from "../../../types/contratos-data-interface";
import { ListaProdutos } from './components/lista-produtos'
import { DiscadorContext } from "../../Discador";
import { ModalInfoDiscador } from '../../Modal/components/info-discador'
import { useAuth } from "../../../context/AuthContext";

interface AtendimentoFormsProps {
  isConsulta?: boolean;
  isCaixa?: boolean;
}

export const AtendimentoForms = ({ isConsulta, isCaixa }: AtendimentoFormsProps) => {
  const [formAba, setFormAba] = useState("Cadastro");
  const {
    devedor,
    credores,
    getSelectedCredor,
  } = useDividas();
  const { clearPropostas } = usePropostas();
  const { contratosData, clearContratos, getContratoCredor, todosContratosData } = useContrato();
  const { getHistorico, clearHistorico } = useHistorico();
  const { clearParcelasNeg } = useNeg()
  const { clearBoleto } = useBoleto();
  const { dadosChamada, onCall } = useContext(DiscadorContext)
  const { getDividasGazin } = useDividas()
  const { cookies } = useAuth()
  // const { clearSelectedFila } = useFila();
  const { modalInfo, onClose, setModal } = useModal();
  const appWS = isCaixa ? "ACIONA_CXA" : 'ACIONA_OPE'

  //Limpar dados td vez q começar com um novo devedor
  useEffect(() => {
    clearPropostas();
    clearContratos();
    clearHistorico();
    clearBoleto();
    clearParcelasNeg()
    // onClose()
    // clearDevedorCadastro()
  }, [devedor.cpf_cnpj]);

  useEffect(() => {
    onClose()
  }, [])

  useEffect(() => {
    if (isCaixa) {
      if (dadosChamada?.mailing?._id && dadosChamada?.mailing?.data) {
        setModal('Discador', 'Discador', false, false);
        getDividasGazin({ cpf_cnpj: dadosChamada?.mailing?.data?.cgc_cpf, app: appWS, usuario: String(cookies?.user?.id_operador), })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dadosChamada?.mailing, isCaixa, onCall])

  // useEffect(() => {
  //   async function getDados() {
  //     await getDividasGazin({
  //       cpf_cnpj: devedor.cpf_cnpj,
  //       id: Number(devedor.id_debtor),
  //       app: 'ACIONA_OPE'
  //     });
  //   }
  //   getDados();
  // }, [devedor.cpf_cnpj]);

  // useEffect(() => {
  //   clearDividas();
  // }, []);

  const [credor, setCredor] = useState<Credor>(credores[0]);

  // const isMutationLogin = useIsMutating({ mutationKey: ['login'] })
  const isMutation = useIsMutating({ mutationKey: ["form"] });

  useEffect(() => {
    setCredor(credores[0])
    getSelectedCredor(credores[0])
    setFormAba("Cadastro");
  }, [credores]);

  // async function getCredor(credor: Credor) {
  //   setCredor(credor);
  //   getSelectedCredor(credor);
  //   await getDevedorCadastro(
  //     credor?.url_ws,
  //     devedor?.cpf_cnpj,
  //     credor?.credor_crm
  //   );
  // }

  useEffect(() => {
    if (credor?.credor_crm && devedor !== null && devedor?.cpf_cnpj) {
      // getContracts({
      //   url: credor?.url_ws,
      //   cpf_cnpj: devedor?.cpf_cnpj,
      //   credor: credor?.credor_crm,
      //   app: 'ACIONA_OPE'
      // });
      if (todosContratosData?.contratos?.length > 0) {
        const c = todosContratosData?.contratos?.find(item => item.codcredor === String(credor.credor_crm))
        const contratos = c ? [c] : [] as Contrato[]
        const contratoCredor: ConsultaContratosData = {
          valorprincipal: todosContratosData?.valorprincipal,
          contratos
        }
        getContratoCredor(contratoCredor)
      }

      getHistorico({
        url: credor?.url_ws,
        cpf_cnpj: devedor?.cpf_cnpj,
        codcredor: String(credor?.credor_crm),
        app: appWS,
        usuario: String(cookies?.user?.id_operador),
      });
    }
  }, [credor]);

  function semAcordos() {
    const permicoes = contratosData.contratos.filter(item => !item.permiteacordo)

    return permicoes?.length > 0 ? true : false
  }


  return (
    <div
      className={`flex max-h-full min-h-full  ${isConsulta ? "w-[100%]" : "w-[80%]"
        } flex-col items-center rounded-md bg-white px-4 py-4`}
    >
      <div className="w-full">
        <ul className=" flex w-full flex-wrap gap-2  ">
          {/* {devedor && credores?.length > 0 ? (
          credores?.map((credo) => ( */}
          <li
            className={`credor 
               
              flex items-center justify-center`}
          // onClick={() => getCredor(credo)}
          // key={credo?.credor_crm}
          >
            <img
              src="https://arquivos-jprosystem.s3.us-east-2.amazonaws.com/imagens/gazin.png"
              alt="logo gazin"
              className="mt-1 w-[3.8rem]"
            />
          </li>
          {/* ))
        ) : (
          <></>
        )} */}
        </ul>
        <div className="border-b-2 border-gray-100 brightness-95"></div>
      </div>

      <div className="text-md mt-8 w-full border-b-2 border-primary text-center text-sm font-medium text-gray-500">
        <ul className="flex flex-wrap gap-2">
          <li
            className={` aba-form ${formAba === "Cadastro" &&
              "  border-2  border-b-0 border-primary text-primary underline"
              }`}
            onClick={() => setFormAba("Cadastro")}
          >
            <p>Cadastro</p>
          </li>
          {/* <li
          // && contratosData.contratos[0].permiteproposta
          className={`${
            formAba === "Propostas" &&
            "border-2 border-b-0 border-primary text-primary underline"
          } ${
            contratosData &&
            contratosData.contratos?.length > 0 &&
            contratosData.contratos[0].permiteproposta
              ? "aba-form"
              : "pointer-events-none flex h-10 items-center justify-center opacity-70"
          } `}
          onClick={() => {
            if (
              contratosData &&
              contratosData.contratos?.length > 0 &&
              contratosData.contratos[0].permiteproposta
            ) {
              setFormAba("Propostas");
            }
          }}
        >
          <p>Propostas</p>
        </li> */}
          <li
            className={` ${formAba === "Negociações" &&
              "border-2 border-b-0 border-primary text-primary underline"
              } ${contratosData && contratosData.contratos?.length > 0 && semAcordos()
                ?
                "aba-form"
                : "pointer-events-none flex h-10 items-center justify-center opacity-70"
              }`}
            onClick={() => {
              if (contratosData && contratosData.contratos?.length > 0 && semAcordos()) {
                setFormAba("Negociações");
              }
            }}
          >
            <p>Negociações</p>
          </li>
          <li
            className={` ${formAba === "Tabulações" &&
              "border-2 border-b-0 border-primary text-primary underline"
              } ${
              // historico.acionamentos
              // historico.acionamentos.acionamento?.length > 0
              // ?
              "aba-form"
              // :
              // "pointer-events-none flex h-10 items-center justify-center opacity-70"
              }`}
            onClick={() => setFormAba("Tabulações")}
          >
            <p>Tabulações</p>
          </li>
          {/* {!isConsulta && (
          <li
            className={` aba-form ${
              formAba === "Origem" &&
              "border-2 border-b-0 border-primary text-primary underline"
            } ${
              devedor?.cpf_cnpj
                ? "aba-form"
                : "pointer-events-none flex h-10 items-center justify-center opacity-70"
            }`}
            onClick={() => setFormAba("Origem")}
          >
            <p>Origem</p>
          </li>
        )} */}
          {/* <li
          className={` aba-form  pointer-events-none opacity-70  ${
            formAba === "Contra Proposta" &&
            "border-2 border-b-0 border-primary text-primary underline"
          } ${
            devedor?.cpf_cnpj
              ? "aba-form"
              : "pointer-events-none flex h-10 items-center justify-center opacity-70"
          }`}
          onClick={() => setFormAba("Contra Proposta")}
        >
          <p>Contra Proposta</p>
        </li> */}
          <li
            className={` aba-form   ${formAba === "2ª via" &&
              "border-2 border-b-0 border-primary text-primary underline"
              } ${devedor?.cpf_cnpj && contratosData?.contratos?.length > 0 && contratosData.contratos.filter(item => item.permiteacordo).length > 0 ? 'aba-form' : 'opacity-70 items-center justify-center flex h-10 pointer-events-none'}`}
            onClick={() => setFormAba("2ª via")}
          >
            <p>2ª via</p>
          </li>

          <li
            className={` ${formAba === "Produtos" &&
              "border-2 border-b-0 border-primary text-primary underline"
              } ${"aba-form"
              }`}
            onClick={() => setFormAba("Produtos")}
          >
            <p>Produtos</p>
          </li>
        </ul>
      </div>

      <div className="mt-4 max-h-full w-full overflow-y-auto">
        {formAba === "Cadastro" && (
          <FormCadastro credor={credor?.credor_crm} url={credor?.url_ws} app={appWS} />
        )}
        {formAba === "Negociações" && <FormNeg isCaixa={isCaixa} />}
        {formAba === "Tabulações" && <Historico app={appWS} />}
        {/* {!isConsulta && formAba === "Origem" && <InfoChamada />} */}
        {/* {formAba === "Propostas" && <FormPropostas />}
        {formAba === "Contra Proposta" && <ContraProposta />} */}
        {formAba === "2ª via" && <SegundaVia app={appWS} />}
        {formAba === "Produtos" && <ListaProdutos />}
        {/* { />} */}
      </div>

      <ModalSucesso />
      <ModalErro app={appWS} setFormAba={setFormAba} />
      <ModalTabFinalizar isOperador app={appWS} />

      <GenericModal
        title={modalInfo.title}
        type={modalInfo.type}
        onClose={() => onClose()}
        show={modalInfo.isOpen && modalInfo.title === "Proximo Atendimento"}
        modalType="Proximo Atendimento"
      />

      <GenericModal
        title={modalInfo.title}
        type={modalInfo.type}
        onClose={() => onClose()}
        show={modalInfo.isOpen && modalInfo.title === "Chat Contato"}
        modalType="Chat Contato"
      />
      {/* 
      <GenericModal
        title={modalInfo.title}
        type={modalInfo.type}
        onClose={() => onClose()}
        show={(modalInfo.isOpen && modalInfo.title === 'Qualificacao Chamada') || (modalInfo.isOpen && modalInfo.title === 'Campanha Discador')}
        modalType="Qualificacao Chamada"
      /> */}

      <ModalInfoDiscador />

      {isMutation > 0 ? (
        <div className=" m absolute z-50 flex min-h-[80%] w-[60%] items-center justify-center bg-white  px-4 py-4 opacity-90">
          <Loader size={3.5} />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};
